import { render, staticRenderFns } from "./FilterText.vue?vue&type=template&id=3616a7bc&scoped=true&"
import script from "./FilterText.vue?vue&type=script&lang=js&"
export * from "./FilterText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3616a7bc",
  null
  
)

export default component.exports